import { createClient } from '@/prismicio';
import { PrismicNextImage } from '@prismicio/next';
import { SliceZone, PrismicText } from '@prismicio/react';
import { components } from '@/slices';

export const Footer = async () => {
  const client = createClient();
  const { data } = await client.getSingle('global_navigation');
  const { data: settings } = await client.getSingle('settings');

  const newsLetter = data.slices1.find(
    (slice: { slice_type: string }) => slice.slice_type === 'news_letter',
  );
  const socialMedia = data.slices1.find(
    (slice: { slice_type: string }) => slice.slice_type === 'social_media',
  );
  const menus = data.slices1.filter(
    (slice: { slice_type: string; variation?: string }) =>
      slice.slice_type === 'submenu' &&
      slice.variation !== 'credits' &&
      slice.variation !== 'awardsStrip',
  );
  const credits = data.slices1.find(
    (slice: { slice_type: string; variation?: string }) =>
      slice.slice_type === 'submenu' && slice.variation === 'credits',
  );
  const awardsStrip = data.slices1.find(
    (slice: { slice_type: string; variation?: string }) =>
      slice.slice_type === 'submenu' && slice.variation === 'awardsStrip',
  );

  return (
    <footer className="bg-[#0E0F0F] text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-20 lg:gap-[113px]">
          <div className="w-full max-w-[500px] flex flex-col gap-8">
            <div className="w-full flex justify-between items-center flex-wrap gap-4">
              <PrismicNextImage
                field={data.company_logo}
                className="w-32 h-auto"
                fallbackAlt=""
                // Explicit dimensions help avoid CLS when the image loads
                width={data.company_logo?.dimensions?.width ?? 128}
                height={data.company_logo?.dimensions?.height ?? 32}
                sizes="(max-width: 768px) 8rem, 8rem"
                priority={false}
              />
              {socialMedia && (
                <SliceZone slices={[socialMedia]} components={components} />
              )}
            </div>
            {newsLetter && (
              <SliceZone
                slices={[newsLetter]}
                components={components}
                context={settings}
              />
            )}
            {awardsStrip && (
              <SliceZone
                slices={[awardsStrip]}
                components={components}
                context={{ isShown: true }}
              />
            )}
          </div>

          {/* Right Column (Menus) */}
          <div className="flex-1 flex flex-col gap-10 items-end lg:items-end md:items-start sm:items-start">
            <div className="grid grid-cols-2 md:grid-cols-2 gap-20 text-left w-full md:w-auto">
              <SliceZone
                slices={menus}
                components={components}
                context={{ isFooter: true }}
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white">
            &copy; {new Date().getFullYear()}{' '}
            <PrismicText field={settings.site_title} />. All rights reserved.
          </p>
          {credits && (
            <div className="[&_a]:underline">
              <SliceZone slices={[credits]} components={components} />
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};
